import { useEffect, useRef, useState } from "react";
import { Head } from "@tecnobit-srl/head-manager";
import md5 from "md5";
import { jsx } from "react/jsx-runtime";
//#region src/index.tsx
function Script({ src, onload, async = true, id }) {
	const [initialized, setInitialized] = useState(false);
	const script = useRef(null);
	useEffect(() => {
		if (!src) return;
		if (!initialized) {
			const oldScript = script.current;
			if (oldScript) {
				try {
					document.head.removeChild(oldScript);
				} catch {}
				script.current = null;
			}
			setInitialized(true);
			const scriptEl = document.createElement("script");
			scriptEl.src = src;
			if (async) scriptEl.async = true;
			if (onload) scriptEl.onload = onload;
			document.head.appendChild(scriptEl);
			script.current = scriptEl;
			return () => {
				try {
					document.head.removeChild(scriptEl);
				} catch {}
				script.current = null;
			};
		}
		return () => {};
	}, [
		async,
		initialized,
		onload,
		src
	]);
	if (!src) return null;
	return /* @__PURE__ */ jsx(Head, {
		headKey: `script-${md5(src)}`,
		children: /* @__PURE__ */ jsx("script", {
			id,
			src,
			onLoad: onload,
			async
		})
	});
}
//#endregion
export { Script };
